import { useSuspenseQuery } from '@tanstack/react-query'

import { GetEmpreendimentoFoldersService } from '@/features/empreendimentos/shared/http/get-empreendimento-folders.service'
import type { TGetEmpreendimentoMidiaResponse } from '@/features/empreendimentos/shared/types/empreendimento'
import { empreendimentosKeys } from '@/features/empreendimentos/shared/utils/queries'

export const useSuspenseEmpreendimentoFolders = (idExterno: number) => {
  return useSuspenseQuery<TGetEmpreendimentoMidiaResponse>({
    queryKey: empreendimentosKeys.folders(idExterno),
    queryFn: () => new GetEmpreendimentoFoldersService().execute(idExterno).then((response) => response.data),
  })
}
